import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import CompanyAdd from './Add';
import CompanyList from './CompanyList';
import SkeletonContainer from '../Layout/SkeletonContainer';
import Search from '../Layout/Search';

class Companies extends Component {

    render(){
        const { getCompanies, companiesMeta } = this.props;
        return (
            <SkeletonContainer title="COMPANIES">
                <Search endpoint="companies" addModal={props => <CompanyAdd {...props}/>} getData={getCompanies} meta={companiesMeta}/>
                <CompanyList />
            </SkeletonContainer>
        );
    }
}
const mapStateToProps = (state) => ({
    companiesMeta: state.companyStore.companiesMeta,
});
export default connect(mapStateToProps,Actions.companies)(Companies);


// WEBPACK FOOTER //
// ./src/Components/App/Companies/index.js